@if (location && maps[location]) {
  <div class="map-holder">
    <img [attr.src]="maps[location]" alt="">
  </div>
}
